import React from 'react';
import { useParams } from 'react-router';
import SearchAcrossSectionsContainerWrapper from '../index';

function SearchAcrossSectionsRoute(props) {
  const { courseId } = useParams();
  const routeProps = {
    ...props,
    courseId,
  };
  return <SearchAcrossSectionsContainerWrapper {...routeProps} />;
}

export default SearchAcrossSectionsRoute;
